
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Veterans from "../pages/veterans/page";
import Families from "../pages/families/page";
import Outreach from "../pages/outreach/page";
import PTSDEducation from "../pages/ptsd-education/page";
import TLD from "../pages/tld/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/veterans",
    element: <Veterans />,
  },
  {
    path: "/families",
    element: <Families />,
  },
  {
    path: "/outreach",
    element: <Outreach />,
  },
  {
    path: "/ptsd-education",
    element: <PTSDEducation />,
  },
  {
    path: "/tld",
    element: <TLD />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
